import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PropTypes } from 'prop-types'
import { Box } from '@mui/material'
import update from 'immutability-helper'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import config from '../../config/config'
import { SubSectionTitle } from './ProjectInputs'
import CustomSlider from './CustomSlider'
import ProjectInfo from './ProjectInfo'
import {
  AUTO,
  BICYCLE,
  FREIGHT,
  PEDESTRIAN,
  TRANSIT
} from '../../constants/modalTiers'
import { setModalPrioritization } from '../../slices/generalInputs/modalPrioritization'
import { SubSectionTitle } from './ProjectInputs'
import { Card } from './Card'
import ProjectInfo from './ProjectInfo'
import { remixStreet } from '../../../streets/remix'
import { setShareableURL } from '../../slices/appSlice'
import { setPrioritiesDictionary } from '../../slices/generalInputs/modalPrioritiesCardDict'
import { themeConfig } from '../../config/theme.config'
import './ProjectInputs.scss'
const step3Illustration = new URL(
  '../../../../images/illustrations/step3-2x.png',
  import.meta.url
)

export const containerStyles = {
  width: '50%'
}

export default function ProjectInputsThree() {
  const dispatch = useDispatch()
  const { modalPrioritization } = useSelector((state) => state)
  const { prioritiesDictionary } = useSelector(
    (state) => state.modalPrioritiesCardDict
  )
  const { modalTiers } = useSelector((state) => state)
  const { shareableURL } = useSelector((state) => state.appSlice)
  const moveCard = useCallback((dragIndex, hoverIndex, tier, shareableURL) => {
    // If URL is shareable, then remix street whenever a field is changed
    if (shareableURL) {
      // remixStreet() -> street remix is done is App.jsx whenever shareableURL is false
      dispatch(setShareableURL(false))
    }
    dispatch(
      setPrioritiesDictionary({
        field: 'prioritiesDictionary',
        value: (prevCards) =>
          update(prevCards, {
            $splice: [
              [dragIndex, 1],
              [hoverIndex, 0, prevCards[dragIndex]]
            ]
          })
      })
    )
  }, [])

  // useEffect(() => {
  //   // Disptach priorities every time card is being dragged
  //   prioritiesDictionary.map((obj, i) =>
  //     dispatch(
  //       setModalPrioritization({
  //         field: `Priority_${i + 1}`,
  //         value: obj.tier
  //       })
  //     )
  //   )
  // }, [prioritiesDictionary])

  const renderCard = useCallback(
    (card, index) => {
      return (
        <Card
          key={card.id}
          index={index}
          id={card.id}
          text={card.text}
          moveCard={moveCard}
          tier={card.tier}
          shareableURL={shareableURL}
          modalTier={card.modalTier}
        />
      )
    },
    [shareableURL]
  )
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '30% 1fr',
        height: '400px',
        gap: '30px'
      }}
      className="project-inputs-main-container"
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        className="img-container"
      >
        <img
          src={step3Illustration}
          style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex'
        }}
        className="inputs-container"
      >
        <Box sx={containerStyles} className="individual-container">
          <Box
            sx={{
              width: '100%'
            }}
          >
            <SubSectionTitle alignSelf="left">
              How important is your street for each user?
            </SubSectionTitle>
            <Box
              sx={{
                width: '100%',
                alignSelf: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '20px'
                }}
              >
                <SubSectionTitle
                  color={themeConfig.semcogBlue1}
                  fontWeight={600}
                  fontSize={12}
                  marginBottom="0.5em"
                >
                  Least Important
                </SubSectionTitle>
                <SubSectionTitle
                  color={themeConfig.semcogBlue1}
                  fontWeight={600}
                  fontSize={12}
                  marginBottom="0.5em"
                >
                  Most Important
                </SubSectionTitle>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              width: '100%',
              alignSelf: 'center'
            }}
          >
            {config.modalTiers.map((obj, index) => {
              return (
                <CustomSlider
                  step={1}
                  min={0}
                  max={3}
                  sliderNote={obj.notes}
                  key={`${obj.name}-slider`}
                  field={obj.name}
                  sliderType="modalTiers"
                  format="modalTiers"
                />
              )
            })}
          </Box>
          <Box
            sx={{
              width: '90%'
            }}
          >
            <ProjectInfo infoText="The level of importance, or Modal Tier, is based on the land use context and modal networks for the street you’ve selected. You can adjust the values to suit your project’s needs." />
          </Box>
        </Box>
        <Box sx={containerStyles} className="individual-container">
          <Box
            sx={{
              width: '100%',
              marginBottom: '0.35em'
            }}
          >
            {' '}
            <SubSectionTitle alignSelf="left">
              What is the priority of users?
            </SubSectionTitle>
          </Box>
          <Box
            sx={{
              width: '100%',
              alignSelf: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Box sx={{ width: '90%', pointerEvents: 'none !important' }}>
              <DndProvider backend={HTML5Backend}>
                {prioritiesDictionary.map((obj, i) => {
                  return renderCard(obj, i)
                })}
              </DndProvider>
            </Box>
          </Box>
          <Box
            sx={{
              width: '90%'
            }}
          >
            <ProjectInfo infoText="Use the sliders to the left to change the priority of users. Note that the priority varies depending on the land use context." />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
